import { useEffect } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { RegistrationLayout } from "../../Layouts";
import AftLogo from "../Images/AftLogo";

export const TERM_LIFE_ENROLLMENT_URL = "https://www.gallagher-affinity.com/programs/aft/products/term-life-insurance";

const TermLifeSpecialOfferExpiredPage = () => {
    useEffect(() => {
        document.title = "AFT Benefits | Term Life Special Offer Has Expired";
    }, []);

    return (
        <RegistrationLayout>
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8} xl={6}>
                    <Card className="bg-light shadow text-center">
                        <Card.Body className="p-4 p-md-5">
                            <AftLogo className="w-50 mb-4" />
                            <h1 className="h3 text-primary mb-3">The 2026 Term Life Special Offer Has Expired</h1>
                            <p className="mb-4">
                                If you're interested in adding MetLife Supplemental Term Life Insurance coverage,
                                please click <a href={TERM_LIFE_ENROLLMENT_URL}>here</a> to enroll in the standard
                                Term Life Insurance Plan for AFT members. If you have additional questions, please
                                contact our customer service team at <a href="tel:8884238700">888.423.8700</a>,
                                Monday&ndash;Friday, 8 a.m.&ndash;8 p.m. ET.
                            </p>
                            <Button variant="primary" size="lg" href={TERM_LIFE_ENROLLMENT_URL}>Enroll Now</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </RegistrationLayout>
    );
};

export default TermLifeSpecialOfferExpiredPage;
